import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-h5 mb-10" }, "Dados bancários", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-h5 my-10" }, "Observações", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-h5 mb-10" }, "Notificações por email", -1)

import AppTemplate from '@/app/shared/ui/templates/AppTemplate.vue';
import { ref, reactive, inject } from 'vue';
import rules from '@/app/shared/domain/data/rules';
import InputAvatar from '@/app/shared/components/inputs/InputAvatar.vue';
import InputDocument from '@/app/shared/components/inputs/InputDocument.vue';
import Client from '@/app/client/domain/interfaces/Client';
import InputCostCenter from '@/app/shared/components/inputs/InputCostCenter.vue';
import InputAddress from '@/app/shared/components/inputs/InputAddress.vue';
import InputBankAccount from '@/app/shared/components/inputs/InputBankAccount.vue';
import ClientRepository from '@/app/client/infrastructure/persistence/ClientRepository';
import Tabs from '@/app/shared/components/Tabs.vue';
import { useForm } from '@/app/shared/ui/composable/form';
import CnpjData from '@/app/shared/domain/classes/CnpjData';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientForm',
  props: ['id'],
  setup(__props) {

const props = __props;

const form = ref(null);

const repository = inject('clientRepository') as ClientRepository;
const picture = ref(null);

let client = reactive({
    image: 'default.jpg',
    notify_os: false,
} as Client);

const { pageTitle, submitAttach } = useForm(
    props,
    client,
    repository,
    form,
    'Editar cliente',
    'Cadastrar cliente',
    '/clientes',
    '/clientes',
);

function submit() {
    submitAttach(picture.value);
}

const tabItens = [
    {
        icon: 'mdi:mdi-book-open',
        key: 'main',
        title: 'Principal'
    },
    {
        icon: 'mdi:mdi-map-marker',
        key: 'address',
        title: 'Endereço'
    },
    {
        icon: 'mdi:mdi-plus-circle-outline',
        key: 'add',
        title: 'Adicionais'
    },
    {
        icon: 'mdi:mdi-cog-outline',
        key: 'config',
        title: 'Configurações'
    },
];

function cnpjDataFound(data: CnpjData) {
    client.name = data.name;
    client.email = data.email;
    client.phone = data.phone;
    client.address = {
        zip_code: data.zipCode,
        street: data.street,
        number: data.number,
        complement: data.complement ?? '',
        neighborhood: data.neighborhood,
        city: data.city,
        state: data.state,
    };
}

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createBlock(AppTemplate, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "space-around" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { width: "100%" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, { color: "surface" }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: submit,
                    "prepend-icon": "mdi:mdi-content-save",
                    color: "primary",
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Salvar")
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(pageTitle)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    "lazy-validation": "",
                    ref_key: "form",
                    ref: form
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Tabs, { itens: tabItens }, {
                        main: _withCtx(() => [
                          _createVNode(_component_v_row, { wrap: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                lg: "2",
                                align: "center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputAvatar, {
                                    "image-path": "clients",
                                    src: _unref(client).image,
                                    modelValue: picture.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((picture).value = $event))
                                  }, null, 8, ["src", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                lg: "10"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(InputDocument, {
                                        modelValue: _unref(client).document,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(client).document) = $event)),
                                        onCnpjDataFound: cnpjDataFound
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            rules: [_unref(rules).required],
                                            label: "Nome",
                                            modelValue: _unref(client).name,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(client).name) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            label: "Email",
                                            rules: [_unref(rules).required, _unref(rules).email],
                                            modelValue: _unref(client).email,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(client).email) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputCostCenter, {
                                            modelValue: _unref(client).cost_center_id,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(client).cost_center_id) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            label: "Telefone",
                                            rules: [_unref(rules).phone],
                                            modelValue: _unref(client).phone,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(client).phone) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '(##)####-####']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            label: "Celular / Whatsapp",
                                            rules: [_unref(rules).phone],
                                            modelValue: _unref(client).cell_phone,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(client).cell_phone) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '(##)#####-####']
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        address: _withCtx(() => [
                          _createVNode(InputAddress, {
                            modelValue: _unref(client).address,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(client).address) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        add: _withCtx(() => [
                          _hoisted_1,
                          _createVNode(InputBankAccount, {
                            modelValue: _unref(client).account,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(client).account) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_divider),
                          _hoisted_2,
                          _createVNode(_component_v_text_field, {
                            label: "Observações",
                            modelValue: _unref(client).observations,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(client).observations) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        config: _withCtx(() => [
                          _hoisted_3,
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_switch, {
                                    modelValue: _unref(client).notify_os,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(client).notify_os) = $event)),
                                    inset: "",
                                    color: "primary",
                                    label: "Fechamento de O.S."
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})